'use client';

import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";

interface EmptyStateProps {
      icon: LucideIcon;
      title: string;
      description: string;
      action?: React.ReactNode;
}

const EmptyState = ({ icon: Icon, title, description, action }: EmptyStateProps) => {
      return (
            <div className="flex flex-col items-center justify-center h-[50vh] gap-4">
                  <motion.div
                        className="rounded-full bg-muted p-8"
                        initial={{ opacity: 0, scale: 0.5 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.3 }}
                  >
                        <Icon className="w-32 h-32 text-muted-foreground" />
                  </motion.div>
                  <motion.div
                        className="text-center space-y-2"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3, delay: 0.1 }}
                  >
                        <h3 className="text-2xl font-medium">{title}</h3>
                        <p className="text-muted-foreground">{description}</p>
                  </motion.div>
                  {action && (
                        <motion.div
                              className="mt-4"
                              initial={{ opacity: 0, y: 20 }}
                              animate={{ opacity: 1, y: 0 }}
                              transition={{ duration: 0.3, delay: 0.2 }}
                        >
                              {action}
                        </motion.div>
                  )}
            </div>
      );
};

export default EmptyState; 